import { useTopBarProps } from '@/shared/layout/top-bar/hooks';
import type { TopBarProps } from '@/shared/layout/top-bar/types';

export function TopBar(props: TopBarProps) {
  const {
    rootProps,
    breadcrumbsProps,
    breadcrumbs,
    slotProps,
    navigationSlot,
    tenantSlot,
    actionsSlot,
    profileSlot,
  } = useTopBarProps(props);

  return (
    <header {...rootProps}>
      <div className="flex items-center gap-2 sm:gap-3">
        {navigationSlot ? <div>{navigationSlot}</div> : null}
        {tenantSlot ? <div {...slotProps}>{tenantSlot}</div> : null}
        {breadcrumbs ? <div {...breadcrumbsProps}>{breadcrumbs}</div> : null}
      </div>
      <div className="flex items-center gap-2 sm:gap-2.5">
        {actionsSlot ? <div {...slotProps}>{actionsSlot}</div> : null}
        {profileSlot ? <div {...slotProps}>{profileSlot}</div> : null}
      </div>
    </header>
  );
}

export { useTopBarProps } from '@/shared/layout/top-bar/hooks';
export type { TopBarProps } from '@/shared/layout/top-bar/types';
